import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initTelegramApp } from "./lib/telegram";
import { checkAppVersion } from "./lib/versionCheck";
import "./index.css";

// ВАЖЛИВО (owner 2026-07-08): init-виклики НЕ повинні блокувати монтування
// React. Раніше `initTelegramApp()` (там `ready()`/`expand()` без try/catch)
// або `checkAppVersion()` при винятку в деяких Telegram-клієнтах кидали помилку
// ДО `ReactDOM.render` → React не монтувався → юзер вічно бачив boot-spinner з
// index.html (кейс @kutnaksu). Тепер обидва в try/catch, а рендер — у finally,
// тож апка стартує ЗАВЖДИ, навіть якщо Telegram-API поводиться дивно.
try {
  // Сообщаем Telegram что Mini App готов.
  initTelegramApp();
} catch (e) {
  console.error("[main] initTelegramApp failed (non-fatal):", e);
}

try {
  // Самоісцільна перевірка версії (анти-кеш).
  checkAppVersion();
} catch (e) {
  console.error("[main] checkAppVersion failed (non-fatal):", e);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
